import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton, {
  shouldForwardProp: prop => prop !== 'align'
})(({ align }) => ({
  ...(align === 'left' && {
    marginLeft: 'auto'
  })
}));

export const FooterMessage = styled('div')(() => ({
  width: '300px'
}));

export const Section = styled('div', {
  shouldForwardProp: prop => prop !== '$wrap' && prop !== '$justify'
})(({ $wrap, $justify }) => ({
  display: 'flex',
  flexGrow: 1,
  flexWrap: $wrap || 'wrap',
  ...($justify && { justifyContent: $justify }),
  '@media (max-width: 768px)': {
    justifyContent: 'right'
  }
}));

export const FooterContent = styled('div', {
  shouldForwardProp: prop => prop !== '$wrap'
})(({ theme, $wrap }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: $wrap || 'wrap',
  margin: theme.spacing(-1.5),
  width: `calc(100% + ${theme.spacing(3)})`,
  [`& ${Button}, & ${FooterMessage}`]: {
    margin: theme.spacing(1.5)
  },
  [`& ${Button}`]: {
    '@media (max-width: 400px)': {
      flex: '1 1 100%'
    }
  },
  [`& ${FooterMessage}`]: {
    flexGrow: 1
  }
}));

export const ActionsFooter = styled('div', {
  shouldForwardProp: prop => prop !== '$danger'
})(({ theme, $danger }) => ({
  borderTop: `1px solid ${theme.color.grey[500]}`,
  boxSizing: 'border-box',
  margin: `0 ${theme.spacing(2.5)}`,
  minWidth: '250px',
  padding: `${theme.spacing(2.5)} 0`,
  ...($danger && {
    backgroundColor: theme.color.danger.main,
    color: theme.color.danger.contrast,
    margin: 0,
    padding: theme.spacing(2.5),
    [`& ${Button}`]: {
      minWidth: '100px'
    }
  })
}));
